require.register("app/graphql/Mutation", function(exports, require, module){
  $0
  
});

